module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@2x-056f3eb8ad8fe9984b8ba51cd4012859.png";